/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as deviceV1 from "./keyapis_device_device_v1.pb"

/**
 * Сервис получения trunk-конфигурации для определенного города
 */

/**
 * Сервис получения trunk-конфигурации для определенного города
 */
export class TrunkConfigServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения trunk-конфигурации.
   * Метод доступен для: admin, bti, service, ltp_first
   */
  GetTrunkConfig = (req: GetTrunkConfigRequestDto, init?: RequestInit): Promise<GetTrunkConfigResponseDto> => {
    return fm.request<GetTrunkConfigRequestDto, GetTrunkConfigResponseDto>(`${this.host}/device/internal/api/v1/trunk_config/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка trunk-конфигураций.
   * Метод доступен для: admin, bti, service, ltp_first
   */
  GetTrunkConfigList = (req?: GetTrunkConfigListRequestDto, init?: RequestInit): Promise<GetTrunkConfigListResponseDto[]> => {
    return fm.list<GetTrunkConfigListRequestDto, GetTrunkConfigListResponseDto>(`${this.host}/device/internal/api/v1/trunk_config/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества trunk-конфигураций.
   * Метод доступен для: admin, bti, service, ltp_first
   */
  GetTrunkConfigCount = (req?: GetTrunkConfigCountRequestDto, init?: RequestInit): Promise<GetTrunkConfigCountResponseDto> => {
    return fm.request<GetTrunkConfigCountRequestDto, GetTrunkConfigCountResponseDto>(`${this.host}/device/internal/api/v1/trunk_config/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания trunk-конфигурации.
   * Поддерживает создание и обновление.
   * Метод доступен для: admin, bti, service, ltp_first
   */
  PostTrunkConfig = (req: PostTrunkConfigRequestDto, init?: RequestInit): Promise<PostTrunkConfigResponseDto> => {
    return fm.request<PostTrunkConfigRequestDto, PostTrunkConfigResponseDto>(`${this.host}/device/internal/api/v1/trunk_config`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод архивации trunk-конфигурации.
   * Метод доступен для: admin, service, device_admin
   */
  DeleteTrunkConfig = (req: DeleteTrunkConfigRequestDto, init?: RequestInit): Promise<DeleteTrunkConfigResponseDto> => {
    return fm.request<DeleteTrunkConfigRequestDto, DeleteTrunkConfigResponseDto>(`${this.host}/device/internal/api/v1/trunk_config/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод разархивации trunk-конфигурации.
   * Метод доступен для: admin, service, device_admin
   */
  PostTrunkConfigRestore = (req: PostTrunkConfigRestoreRequestDto, init?: RequestInit): Promise<PostTrunkConfigRestoreResponseDto> => {
    return fm.request<PostTrunkConfigRestoreRequestDto, PostTrunkConfigRestoreResponseDto>(`${this.host}/device/internal/api/v1/trunk_config/restore/${encodeURIComponent(req.id)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки;
 */
export enum TrunkConfigPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки;
 */
export type TrunkConfigPagingDirectionTypeResponseEnum = keyof typeof TrunkConfigPagingDirectionType
/**
 * Справочник типов направлений сортировки;
 */
export type TrunkConfigPagingDirectionTypeRequestEnum = Exclude<TrunkConfigPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum TrunkConfigPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type TrunkConfigPagingOrderByTypeResponseEnum = keyof typeof TrunkConfigPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type TrunkConfigPagingOrderByTypeRequestEnum = Exclude<TrunkConfigPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления Trunk-конфигурации
 */
export type DeleteTrunkConfigRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления Trunk-конфигурации
 */
export type DeleteTrunkConfigResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteTrunkConfigResponseErrorDto
}>
/**
 * Ошибка запроса восстановления Trunk-конфигурации
 */
export type DeleteTrunkConfigResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса восстановления Trunk-конфигурации
 */
export type DeleteTrunkConfigResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение количества Trunk-конфигураций
 */
export type GetTrunkConfigCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: TrunkConfigFilterRequestDto | null
}
/**
 * Ответ на запрос количества Trunk-конфигураций
 */
export type GetTrunkConfigCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего Trunk-конфигураций
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetTrunkConfigCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества Trunk-конфигураций
 */
export type GetTrunkConfigCountResponseErrorRequestDto = {
  /**
   * Ошибка валидации
   */
  validationError?: deviceV1.ValidationErrorRequestDto | null
}
/**
 * Ошибка запроса получения количества Trunk-конфигураций
 */
export type GetTrunkConfigCountResponseErrorDto = {
  /**
   * Ошибка валидации
   */
  validationError: deviceV1.ValidationErrorResponseDto | null
}
/**
 * Запрос на получение списка Trunk-конфигураций
 */
export type GetTrunkConfigListRequestDto = {
  /**
   * Фильтр
   */
  filter?: TrunkConfigFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: TrunkConfigPagingRequestDto
}>
/**
 * Ответ на запрос списка Trunk-конфигураций
 */
export type GetTrunkConfigListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Trunk-конфигурация
   */
  readonly data: TrunkConfigResponseDto
  /**
   * Ошибка
   */
  readonly error: GetTrunkConfigListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка Trunk-конфигураций
 */
export type GetTrunkConfigListResponseErrorRequestDto = {
  /**
   * Ошибка валидации
   */
  validationError?: deviceV1.ValidationErrorRequestDto | null
}
/**
 * Ошибка запроса получения списка Trunk-конфигураций
 */
export type GetTrunkConfigListResponseErrorDto = {
  /**
   * Ошибка валидации
   */
  validationError: deviceV1.ValidationErrorResponseDto | null
}
/**
 * Запрос на получение Trunk-конфигурации
 */
export type GetTrunkConfigRequestDto = {
  /**
   * Идентификатор трубки.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос Trunk-конфигурации
 */
export type GetTrunkConfigResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Trunk-конфигурация
   */
  readonly data: TrunkConfigResponseDto
  /**
   * Ошибка
   */
  readonly error: GetTrunkConfigResponseErrorDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetTrunkConfigResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения баннера
 */
export type GetTrunkConfigResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения Trunk-конфигурации по идентификатору
 */
export type PostTrunkConfigRequestDto = {
  /**
   * Trunk-конфигурации
   */
  data: TrunkConfigRequestDto
}
/**
 * Ответ на запрос сохранения Trunk-конфигурации по идентификатору
 */
export type PostTrunkConfigResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: TrunkConfigResponseDto
  /**
   * Ошибка
   */
  readonly error: PostTrunkConfigResponseErrorDto
}>
/**
 * Ошибка запроса сохранения Trunk-конфигурации
 */
export type PostTrunkConfigResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: TrunkConfigSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения Trunk-конфигурации
 */
export type PostTrunkConfigResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: TrunkConfigSavingErrorResponseDto
}>
/**
 * Запрос разархивации Trunk-конфигурации по идентификатору
 */
export type PostTrunkConfigRestoreRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
}
/**
 * Отвест на запрос разархивации Trunk-конфигурации по идентификатору
 */
export type PostTrunkConfigRestoreResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostTrunkConfigRestoreResponseErrorDto
}>
/**
 * Ошибка запроса разархивации Trunk-конфигурации
 */
export type PostTrunkConfigRestoreResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса разархивации Trunk-конфигурации
 */
export type PostTrunkConfigRestoreResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: deviceV1.ValidationErrorResponseDto
}>
/**
 * Trunk-конфигурация.
 * # Описание модели
 */
export type TrunkConfigRequestDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id?: string
  /**
   * ОРПОН Города
   */
  cityOrponId: string
  /**
   * Тип Trunk-аккаунта
   */
  deviceSipTrunkSipType: deviceV1.DeviceSipTrunkSipTypeRequestEnum
  /**
   * IP-адрес.
   * # Диапазон: 7..15
   */
  ipAddress: string
  /**
   * Порт.
   * # Диапазон: 0..65535
   */
  port: number
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt?: string | null
}
/**
 * Trunk-конфигурация.
 * # Описание модели
 */
export type TrunkConfigResponseDto = {
  /**
   * Идентификатор.
   * # Тип: Guid
   */
  id: string
  /**
   * ОРПОН Города
   */
  cityOrponId: string
  /**
   * Тип Trunk-аккаунта
   */
  deviceSipTrunkSipType: deviceV1.DeviceSipTrunkSipTypeResponseEnum
  /**
   * IP-адрес.
   * # Диапазон: 7..15
   */
  ipAddress: string
  /**
   * Порт.
   * # Диапазон: 0..65535
   */
  port: number
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime?
   */
  readonly deletedAt: string | null
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type TrunkConfigSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: TrunkConfigSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type TrunkConfigSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: TrunkConfigSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type TrunkConfigSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at оличаются
 */
export type TrunkConfigSavingErrorConflictResponseDto = {
}
/**
 * Фильтр для Trunk-конфигураций
 */
export type TrunkConfigFilterRequestDto = {
  /**
   * Фильтр по ОРПОН идентификаторам города
   */
  cityOrponIds?: string[]
  /**
   * Фильтр по IP-адресам
   */
  ipAddresses?: string[]
  /**
   * Показывать удаленные
   */
  showDeleted?: boolean | null
}
/**
 * Фильтр для Trunk-конфигураций
 */
export type TrunkConfigFilterResponseDto = {
  /**
   * Фильтр по ОРПОН идентификаторам города
   */
  cityOrponIds: string[]
  /**
   * Фильтр по IP-адресам
   */
  ipAddresses: string[]
  /**
   * Показывать удаленные
   */
  showDeleted: boolean | null
}
/**
 * Постраничный вывод
 */
export type TrunkConfigPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: TrunkConfigPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: TrunkConfigPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type TrunkConfigPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: TrunkConfigPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: TrunkConfigPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления Trunk-конфигурации
   */
  "DeleteTrunkConfigRequest": {
    "kind": "class",
    "text": "Запрос удаления Trunk-конфигурации",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления Trunk-конфигурации
   */
  "DeleteTrunkConfigResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления Trunk-конфигурации",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteTrunkConfigResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса восстановления Trunk-конфигурации
   */
  "DeleteTrunkConfigResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса восстановления Trunk-конфигурации",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение количества Trunk-конфигураций
   */
  "GetTrunkConfigCountRequest": {
    "kind": "class",
    "text": "Запрос на получение количества Trunk-конфигураций",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "TrunkConfigFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос количества Trunk-конфигураций
   */
  "GetTrunkConfigCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос количества Trunk-конфигураций",
    "fields": {
      /**
       * Всего Trunk-конфигураций
       */
      "data": {
        "type": "int32",
        "text": "Всего Trunk-конфигураций",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTrunkConfigCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества Trunk-конфигураций
   */
  "GetTrunkConfigCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества Trunk-конфигураций",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка Trunk-конфигураций
   */
  "GetTrunkConfigListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка Trunk-конфигураций",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "TrunkConfigFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "TrunkConfigPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос списка Trunk-конфигураций
   */
  "GetTrunkConfigListResponse": {
    "kind": "class",
    "text": "Ответ на запрос списка Trunk-конфигураций",
    "fields": {
      /**
       * Trunk-конфигурация
       */
      "data": {
        "type": "TrunkConfig",
        "text": "Trunk-конфигурация",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTrunkConfigListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка Trunk-конфигураций
   */
  "GetTrunkConfigListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка Trunk-конфигураций",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение Trunk-конфигурации
   */
  "GetTrunkConfigRequest": {
    "kind": "class",
    "text": "Запрос на получение Trunk-конфигурации",
    "fields": {
      /**
       * Идентификатор трубки.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор трубки.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос Trunk-конфигурации
   */
  "GetTrunkConfigResponse": {
    "kind": "class",
    "text": "Ответ на запрос Trunk-конфигурации",
    "fields": {
      /**
       * Trunk-конфигурация
       */
      "data": {
        "type": "TrunkConfig",
        "text": "Trunk-конфигурация",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetTrunkConfigResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения баннера
   */
  "GetTrunkConfigResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения баннера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения Trunk-конфигурации по идентификатору
   */
  "PostTrunkConfigRequest": {
    "kind": "class",
    "text": "Запрос сохранения Trunk-конфигурации по идентификатору",
    "fields": {
      /**
       * Trunk-конфигурации
       */
      "data": {
        "type": "TrunkConfig",
        "text": "Trunk-конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения Trunk-конфигурации по идентификатору
   */
  "PostTrunkConfigResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения Trunk-конфигурации по идентификатору",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "TrunkConfig",
        "text": "Профиль шифрования",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostTrunkConfigResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения Trunk-конфигурации
   */
  "PostTrunkConfigResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения Trunk-конфигурации",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "TrunkConfig.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос разархивации Trunk-конфигурации по идентификатору
   */
  "PostTrunkConfigRestoreRequest": {
    "kind": "class",
    "text": "Запрос разархивации Trunk-конфигурации по идентификатору",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Отвест на запрос разархивации Trunk-конфигурации по идентификатору
   */
  "PostTrunkConfigRestoreResponse": {
    "kind": "class",
    "text": "Отвест на запрос разархивации Trunk-конфигурации по идентификатору",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostTrunkConfigRestoreResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса разархивации Trunk-конфигурации
   */
  "PostTrunkConfigRestoreResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса разархивации Trunk-конфигурации",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Trunk-конфигурация.
   * # Описание модели
   */
  "TrunkConfig": {
    "kind": "class",
    "text": "Trunk-конфигурация.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\n# Тип: Guid",
      },
      /**
       * ОРПОН Города
       */
      "cityOrponId": {
        "type": "int64",
        "text": "ОРПОН Города",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип Trunk-аккаунта
       */
      "deviceSipTrunkSipType": {
        "type": "Device.SipTrunk.SipType",
        "text": "Тип Trunk-аккаунта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * IP-адрес.
       * # Диапазон: 7..15
       */
      "ipAddress": {
        "type": "string",
        "text": "IP-адрес.\n# Диапазон: 7..15",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 7,
            "message": "Значение не входит в допустимый диапазон. Минимум: 7"
          },
          "maxLength": {
            "value": 15,
            "message": "Значение не входит в допустимый диапазон. Максимум: 15"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 0..65535
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 0..65535",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65535,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65535"
          },
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime?
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime?",
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "TrunkConfig.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "TrunkConfig.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at оличаются
   */
  "TrunkConfig.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at оличаются",
  },
  /**
   * Фильтр для Trunk-конфигураций
   */
  "TrunkConfigFilter": {
    "kind": "class",
    "text": "Фильтр для Trunk-конфигураций",
    "fields": {
      /**
       * Фильтр по ОРПОН идентификаторам города
       */
      "cityOrponIds": {
        "type": "int64",
        "text": "Фильтр по ОРПОН идентификаторам города",
      },
      /**
       * Фильтр по IP-адресам
       */
      "ipAddresses": {
        "type": "string",
        "text": "Фильтр по IP-адресам",
      },
      /**
       * Показывать удаленные
       */
      "showDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Показывать удаленные",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "TrunkConfigPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "TrunkConfigPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "TrunkConfigPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Справочник типов направлений сортировки;
   */
  "TrunkConfigPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки;",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "TrunkConfigPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 2,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 3,
        "text": "Дата создания",
      },
    },
  },
}